import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_FRONTEND,
  environment: import.meta.env.MODE, // 'development' or 'production'

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Performance Monitoring
  tracesSampleRate: 0.1, // Capture 100% of transactions (reduce in production)

  // Session Replay
  replaysSessionSampleRate: 0.05, // 10% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

  // Filter out sensitive data
  beforeSend(event) {
    // Don't send errors in development
    if (import.meta.env.MODE === "development") {
      return null;
    }

    // Filter out specific errors (optional)
    if (event.exception?.values?.[0]?.value?.includes("ResizeObserver")) {
      return null; // Ignore ResizeObserver errors
    }

    return event;
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
